// Vanilla
var httpRequest = new XMLHttpRequest()
httpRequest.onreadystatechange = function (data) {
  // code
}
httpRequest.open('GET', 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js');
httpRequest.send();
var timeout = ( function(){ var timers = {}; return function( callback, ms, x_id ){ if ( !x_id ){ x_id = ''; } if ( timers[x_id] ){ clearTimeout( timers[x_id] ); } timers[x_id] = setTimeout( callback, ms ); }; })()
jQuery(document).ready(function ($) {
  $('.faq-q').click(function () {
    $(this).toggleClass('active');
    var faqq = $(this).next();
    $(faqq).slideToggle("slow", function () {
    });
  });
  $( 'a' ).click( function(e){
    if( this.hash && $( this.hash ).offset() ){
      e.preventDefault();
      window.scrollTo({
        top: $( this.hash ).offset().top, 
        behavior: 'smooth'
      });
    }      
  });
  $('.click-here').click(function () {
    $(this).toggleClass('active');
    var faqq = $(this).next();
    $(faqq).slideToggle("slow", function () {});
  });
  $('.menu-icon i').click(function () {
    $(this).toggleClass('active');
    $('.toggle-menu-wrap').slideToggle("slow", function () {});
  });
  $("#owl-carousel2").owlCarousel({
      loop: true,
      items: 1,
      nav:true,
      slideSpeed: 2000,
      autoplay: false,
      thumbs: true,
      dots: false,
      thumbImage: true,
      thumbContainerClass: "owl-thumbs",
      thumbItemClass: "owl-thumb-item"
    });
  $('.lp-owlCarousel').owlCarousel({
      loop: false,
      margin: 20,
      nav: true,
      dots: false,
      margin: 45,
      thumbImage: false,
      //autoHeight: true,
      responsiveClass: true,
      responsive: {
          0: {
              items: 1,
            dots: true
          },
          901: {
              items: 3,
            dots: false
          }
      }
  });  
  var xy = $( '.get-yours.active-option' ).attr( 'href' );
  $( '.get-yours-btn' ).attr( 'href', xy );
  $( '.get-yours' ).click(function(e){
    var x = $( this ).attr( 'href' );
    var y = $( this ).attr( 'classid' );
    $('.switchprice').hide();
    $(y).show();
    $('.get-yours').removeClass( 'active-option' );
    $( this ).addClass( 'active-option' );
    $( '.get-yours-btn' ).attr( 'href', x );
  });
  loop();
  mslider();
  $( window ).resize( function(){
      timeout( function(){
        loop();
        mslider();
      }, 200 );
  });
  function loop(){
    if($('.loop').length && window.innerWidth < 1024){
      $('.loop').owlCarousel({
        center: true,
        items:1,
        loop:true,
        nav: true,
        dots: false
      });
    }else{
      $('.loop').owlCarousel('destroy');
    }
  }
  function mslider(){
    if($('.m-slider').length && window.innerWidth < 1024){
      $('.m-slider').addClass( 'owl-carousel owl-theme' );
      $('.m-slider').owlCarousel({
        center: true,
        items:1,
        loop:false,
        nav: true,
        dots: false
      });
    }else{
      $('.m-slider').owlCarousel('destroy');
      $('.m-slider').removeClass( 'owl-carousel owl-theme' );
    }
  }
});